import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/jushuitan_shop_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  shop_name_cont: {
    model_name: 'JushuitanShop',
    column_type: 'string',
    column_name: 'shopName',
  },
  shop_type_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'JushuitanShop',
      options: ['online', 'offline'],
    },
    model_name: 'JushuitanShop',
    column_name: 'shopType',
  },
  finance_receivable: {
    model_name: 'JushuitanShop',
    column_type: 'string',
    column_name: 'financeReceivable',
  },
}
export const formColumnsConfig = {
  'self': {
    'shop_type': { required: true, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('JushuitanShop', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('JushuitanShop', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
